const steps = [
  {
    number: '01',
    title: 'Диагностика',
    desc: 'Интервью с руководством, анализ текущей ситуации, выявление проблем и целей командообразования.',
    icon: 'ri-search-line',
  },
  {
    number: '02',
    title: 'Постановка целей',
    desc: 'Формулировка конкретных измеримых целей: что должно измениться в команде и бизнесе.',
    icon: 'ri-focus-3-line',
  },
  {
    number: '03',
    title: 'Подготовка программы',
    desc: 'Разработка индивидуальной программы: формат, методы, материалы, кейсы под специфику компании.',
    icon: 'ri-file-list-line',
  },
  {
    number: '04',
    title: 'Проведение',
    desc: 'Тренинг, бизнес-игра или стратегическая сессия с фасилитацией. Живое взаимодействие и опыт.',
    icon: 'ri-presentation-line',
  },
  {
    number: '05',
    title: 'Разбор',
    desc: 'Глубокая рефлексия: что произошло, почему, какие инсайты, что это значит для работы.',
    icon: 'ri-discuss-line',
  },
  {
    number: '06',
    title: 'План внедрения',
    desc: 'Конкретные шаги по переносу инсайтов в рабочую среду: правила, процессы, ответственные.',
    icon: 'ri-road-map-line',
  },
  {
    number: '07',
    title: 'Поддержка',
    desc: 'Сопровождение внедрения, дополнительные сессии, корректировка под реальные условия.',
    icon: 'ri-customer-service-2-line',
  },
];

export default function HowItGoes() {
  return (
    <section id="process" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как проходит корпоративное командообразование
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Не просто «провели тренинг и забыли». Полный цикл от диагностики до внедрения результатов в работу компании.
        </p>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-6">
            {steps.map((step, i) => (
              <div key={i} className="flex items-start gap-4 md:gap-6">
                <div className="flex flex-col items-center">
                  <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </div>
                  {i < steps.length - 1 && (
                    <div className="w-0.5 h-8 bg-teal-200 mt-2"></div>
                  )}
                </div>
                <div className="bg-white rounded-xl p-5 md:p-6 border border-gray-200 flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-sm font-bold text-teal-600">{step.number}</span>
                    <h3 className="text-lg font-bold text-gray-900">{step.title}</h3>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}